import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logowhite from "../../assets/logowhite.png";
import toast from "react-hot-toast";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const Forgetpassword = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState(null);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [activeTab, setActiveTab] = useState(1);
  const [token, setToken] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showNewPwd, setShowNewPwd] = useState(false);
  const [showConformPwd, setConformNewPwd] = useState(false);

  // Email validation
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // Password strength validation (Minimum 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char)
  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  // first API
  const forgetPassword = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      return toast.error("Please enter a valid email address");
    }

    if (!mobileNo || mobileNo.length !== 10) {
      return toast.error("Mobile number must be 10 digits");
    }

    try {
      const response = await fetch(`${apiUrl}/api/v2/users/password/forgot`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email,
          mobile: mobileNo,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success(data?.entities?.message);
        setActiveTab(2);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching forgot password:", error);
    }
  };

  // second API
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${apiUrl}/api/v2/users/password/verify-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            otp: otp,
            email: email,
          }),
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success(data?.entities?.message);
        setActiveTab(3);
        setToken(data?.entities?.resetToken);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching forgot password:", error);
    }
  };

  // third API
  const handleResetSubmit = async (e) => {
    e.preventDefault();
    if (!validatePassword(newPassword)) {
      return toast.error(
        "Password must be 8+ characters, include uppercase, lowercase, number, and special character."
      );
    }

    if (newPassword !== confirmNewPassword) {
      return toast.error("New password and confirm password must match");
    }

    if (newPassword !== confirmNewPassword)
      return toast.error(
        "Check the new password and conform password are same"
      );
    try {
      const response = await fetch(`${apiUrl}/api/v2/users/password/reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          resetToken: token,
          newPassword: newPassword,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success(data?.entities?.message);
        navigate("/");
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching forgot password:", error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white/20 max-w-md mx-auto backdrop-blur-sm p-8 rounded-xl shadow-md w-full mt-10 md:mt-0">
        <img className="w-[150px] mb-4 mx-auto" src={logowhite} alt="Logo" />

        {activeTab === 1 ? (
          <form onSubmit={forgetPassword} className="space-y-5">
            <div>
              <label className="text-white font-medium mb-1 block">
                Enter email Address
              </label>
              <input
                type="text"
                className="w-full p-3 rounded-lg bg-white/70 focus:outline-none"
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div>
              <label className="text-white font-medium mb-1 block">
                Enter Mobile Number
              </label>
              <input
                type="text"
                className="w-full p-3 rounded-lg bg-white/70 focus:outline-none"
                placeholder="Enter Mobile Number"
                value={mobileNo}
                maxLength={10}
                onChange={(e) => setMobileNo(e.target.value)}
                required
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-full transition duration-300"
            >
              Submit
            </button>
          </form>
        ) : activeTab === 2 ? (
          <form onSubmit={handleOtpSubmit} className="space-y-5">
            <div>
              <label className="text-white font-medium mb-1 block">
                Enter OTP
              </label>
              <input
                type="text"
                className="w-full p-3 rounded-lg bg-white/70 focus:outline-none"
                placeholder="Enter OTP"
                value={otp}
                maxLength={6}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-full transition duration-300"
            >
              Submit
            </button>
          </form>
        ) : (
          <form onSubmit={handleResetSubmit} className="space-y-5">
            <div className="relative">
              <label className="text-white font-medium mb-1 block">
                Enter New Password
              </label>
              <input
                type={showNewPwd ? "text" : "password"}
                className="w-full p-3 rounded-lg bg-white/70 focus:outline-none"
                placeholder="Enter New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowNewPwd((prev) => !prev)}
                className="absolute right-4 top-[65%] -translate-y-1/2 text-gray-600"
              >
                {showNewPwd ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>

            <div className="relative">
              <label className="text-white font-medium mb-1 block">
                Confirm New Password
              </label>
              <input
                type={showConformPwd ? "text" : "password"}
                className="w-full p-3 rounded-lg bg-white/70 focus:outline-none"
                placeholder="Confirm New Password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setConformNewPwd((prev) => !prev)}
                className="absolute right-4 top-[65%] -translate-y-1/2 text-gray-600"
              >
                {showConformPwd ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </button>
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-full transition duration-300"
            >
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Forgetpassword;
